import { Heading, Text } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'

interface Props {
  description: string
}

const Description = ({ description }: Props) => {
  return (
    <S.Wrapper>
      <Heading as="h2" size="mega" noMargin color="n900">
        Descrição
      </Heading>
      <Text size="kilo" color="n900">
        {description}
      </Text>
    </S.Wrapper>
  )
}

export default Description
